const headList = [
  { name: '优质视频', id: 'videoRank' },
  { name: '达人涨粉', id: 'newFansRank' },
  { name: '达人播放', id: 'newPlayRank' },
  { name: '制作人排行', id: 'producerRank' }
]

export { headList }
